/**
 * Email validation
 */
export function isValidEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}

/**
 * Password strength (min 6 chars)
 */
export function isValidPassword(pwd) {
  return typeof pwd === 'string' && pwd.length >= 6
}

/**
 * Trade password (6 digits)
 */
export function isValidTradePwd(pwd) {
  return /^\d{6}$/.test(pwd)
}

/**
 * Non-empty check
 */
export function isRequired(val) {
  return val !== null && val !== undefined && String(val).trim() !== ''
}
